import { DashboardLayout } from "@/components";
import { authMiddleware } from "@/middleware";
import { OrderDetails } from "@/pages/orders/details";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_market/orders/$orderId")({
	validateSearch: (search: Record<string, unknown>): { tab?: string } => ({
		tab: ["0", "1", "2", "3", "4"].includes(String(search.tab))
			? String(search.tab)
			: undefined,
	}),
	component: () => {
		const { orderId } = Route.useParams();
		const { tab } = Route.useSearch();
		const navigate = Route.useNavigate();

		return (
			<DashboardLayout>
				<OrderDetails
					orderId={orderId}
					tabValue={tab ?? "0"}
					onTabChange={(tab) => navigate({ search: { tab }, replace: true })}
				/>
			</DashboardLayout>
		);
	},
	loader: authMiddleware,
});
